export const I18N_REDIRECT_COOKIE_NAME = 'i18n_redirected'
